/** @format */

import Head from "next/head";
import parse from "html-react-parser";
import { useTranslation } from 'react-i18next';

const SEO = ({
  title,
  description,
  keywords,
  ogImage,
  ogType,
  canonicalURL,
  isRobotsIndexed = true
}: any) => {
  const { i18n } = useTranslation();

  const baseUrl = process.env.NEXT_PUBLIC_BASE_URL || 'https://www.taxworkoutgroup.net';
  const currentPath = typeof window !== "undefined" ? window.location.pathname : "";

  const locale = i18n.language;

  const enHref = `${baseUrl}${currentPath.replace(/^\/es\//, '')}`;
  const esHref = `${baseUrl}/es${currentPath}`


  return (
    <Head>
      <title>{parse(title)}</title>
      <meta name='description' content={parse(description) as string} />
      {isRobotsIndexed ? (
        <meta name="robots" content="index, follow" />
      ) : (
        <meta name="robots" content="noindex, nofollow" />
      )}

      {keywords && <meta name='keywords' content={keywords} />}
      <meta property='og:title' content={parse(title) as string} />
      <meta property='og:description' content={parse(description) as string} />
      <meta property='og:image' content={ogImage} />
      <meta property='og:type' content={ogType} />
      <link rel='canonical' href={canonicalURL} />

      {/* Dynamic hreflang links */}
      {/* <link rel="alternate" hrefLang="en" href={`${baseUrl}/en/`} />
      <link rel="alternate" hrefLang="es" href={`${baseUrl}/es/`} /> */}
      <link rel="alternate" hrefLang="en" href={enHref} />
      <link rel="alternate" hrefLang="es" href={esHref} />

      <script
        type="text/javascript"
        id="mynewscript"
        dangerouslySetInnerHTML={{
          __html: `(function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
              })(window, document, "clarity", "script", "r1qw4cn2oa");`
        }}
      />
    </Head>
  );
};
export default SEO;
